import { render, staticRenderFns } from "./ColorPicker.vue?vue&type=template&id=3a371b6a"
import script from "./ColorPicker.vue?vue&type=script&lang=js"
export * from "./ColorPicker.vue?vue&type=script&lang=js"
import style0 from "./ColorPicker.vue?vue&type=style&index=0&id=3a371b6a&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a371b6a')) {
      api.createRecord('3a371b6a', component.options)
    } else {
      api.reload('3a371b6a', component.options)
    }
    module.hot.accept("./ColorPicker.vue?vue&type=template&id=3a371b6a", function () {
      api.rerender('3a371b6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/color-picker/ColorPicker.vue"
export default component.exports